import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { componentsTokens } from 'theme/components/components.tokens';
import { primitiveTokens } from 'theme/primitive.tokens';
import { semanticTokens } from 'theme/semantic.tokens';

import type { AuraBaseDesignTokens } from '@primeuix/themes/aura/base';
import type { Preset } from '@primeuix/themes/types';

const themePresetTokens: Preset<AuraBaseDesignTokens> = {
  primitive: primitiveTokens,
  semantic: semanticTokens,
  components: componentsTokens,
};

export const primeNGThemePreset = definePreset(Aura, themePresetTokens);
